import { useRef, useState } from 'react';
import { categories } from '@/data/categories';
import { categoryImages } from '@/data/categoryImages';

export default function CategoryGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  function checkScroll() {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  }

  function scroll(dir: 'left' | 'right') {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 320;
    el.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' });
    setTimeout(checkScroll, 400);
  }

  return (
    <section className="relative w-full bg-foreground-950 py-16 md:py-20 overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 border border-white/20 rounded-full text-white/60 text-xs font-medium uppercase tracking-wider mb-4">
              Browse 14 Categories
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight">
              Shop Everything
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg" />
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-lg" />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          onScroll={checkScroll}
          data-product-shop=""
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[220px] md:w-[260px] group cursor-pointer"
            >
              <div className="bg-background-100 rounded-2xl overflow-hidden mb-3 aspect-square relative">
                <img
                  src={categoryImages[idx]}
                  alt={`${cat.name} - Superbuy Spreadsheet`}
                  title={`${cat.name} products on Superbuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <h3 className="text-white font-semibold text-sm md:text-base mb-1">{cat.name}</h3>
              <p className="text-white/50 text-xs md:text-sm">{cat.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}